<template>
  <div :class="['d-flex flex-column', { 'gap-1': isLeaf, 'gap-2': !isLeaf }]">
    <span :class="depth != 0 ? 'font-size-14' : ''">
      {{ title }}
    </span>
    <template v-if="!isLeaf">
      <required-question-group
        v-for="(content, title) in groups"
        :key="title"
        :title="title"
        v-bind="
          isArray(content)
            ? { questions: content, isLeaf: true, depth: depth + 1 }
            : { groups: content, depth: depth + 1 }
        "
      />
    </template>
    <div v-else class="d-flex flex-column align-start gap-1">
      <router-link
        v-for="(question, i) in questions"
        :key="i"
        class="font-size-12 text-decoration-none"
        :to="{ query: { phase: question.phase }, hash: question.key }"
      >
        {{ question.title }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { PropsDefinition } from '@/_typedefs'
import { isArray } from 'lodash'

/**
 * @typedef {{title: string, key: string, phase: string}} QuestionItem
 * @typedef {{title: string, questions: QuestionItem[], isLeaf: boolean, depth: number}} LeafGroup
 * @typedef {{title: string, groups: Record<string, object>, depth: number}} NodeGroup
 */

export default {
  name: 'RequiredQuestionGroup',
  /** @type {PropsDefinition<NodeGroup & LeafGroup>} */
  props: {
    title: {
      type: String,
      required: true,
    },
    groups: {
      type: Object,
      default: null,
    },
    questions: {
      type: Array,
      default: null,
    },
    isLeaf: {
      type: Boolean,
      default: false,
    },
    depth: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    isArray,
  },
}
</script>

<style></style>
